import React, { useContext } from "react";
import AdminPhoto from "./AdminPhoto";
import AuthContext from "../../context/auth/authContext";
import { Link } from "react-router-dom";

import * as FaIcons from "react-icons/fa";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const AdminHeader = () => {
  const authContext = useContext(AuthContext);
  
  const { user } = authContext;
  const adminContext = useContext(AdminRegistrationContext);
  const { sidebarOpen, toggleSidebar } = adminContext;
  return (
    <div className="admin-header">
      <div className="wrapper">
        <div className="container">
          <div className="left">
             <FaIcons.FaBars
              className="ham-bars"
              onClick={toggleSidebar}
            />
          </div>
          <div className="right">
            {user && <span>Hello, {user.name.split(" ")[0]}</span>}
            <AdminPhoto />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
